import conxtdOut from 'apis/conxtdOut';
import React, { useEffect, useState, useCallback, useRef } from 'react';
import { Button, Modal, Row, Col, Form } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import Icon from 'components/Icons/Icon';
import Loading from "components/Loading";
import Alert from "components/Common/Alert";
import Progress from "components/Common/EnterpriseManager/Progress";
import Message from "components/Common/EnterpriseManager/Message";
import { saveAs } from "file-saver";
// import { useIsMounted } from 'components/Common/CustomHooks/useIsMounted';
import Axios from '../../../../../../../node_modules/axios/index';
// import SaveSiteSuccess from "../../../AddSingleSite/SaveSiteSuccess";
import "./AssetImportExport.scss"
import { loadCompanyAssetsStart } from 'services/redux/actions/serviceDesk';
// import ButterToast, { Cinnamon } from 'butter-toast';
import { showSuccessfulToast } from './Toasts/ImportLinkToasts/showSuccessfulToast';
import { showFailedToast } from './Toasts/ImportLinkToasts/showFailedToast';
import { getCompanyIdFromRoute } from 'services/redux/selectors/company';
import CategorySelection from '../AddSiteAsset/CategorySelection';
import { Tooltip } from 'components/Common/Tooltip/Tooltip';

function BulkImportAssets({ 
  showImportModal, 
  setShowImportModal, 
  categoriesList, 
  loadingCategories, 
  importIsUpdate,
  importIsCategory,
  categoryId,
  setCategoryId,
  setShowImportStatus,
  submittingToast,
  }) {

  const dispatch = useDispatch();
  const history = useHistory();

  const companyId = useSelector(getCompanyIdFromRoute);
  const darkMode = useSelector(state => state.app.darkMode);

  const [downloadingTemplate, setDownloadingTemplate] = useState(false);
  const [uploadingSites, setUploadingSites] = useState(false);
  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState("");
  const [uploadPercentage, setUploadPercentage] = useState(0);
  // const [importErrors, setImportErrors] = useState([]);
  const [message, setMessage] = useState("");
  
  const [clipboardMessage, setClipboardMessage] = useState({label: "", area: ""});
  const [hideClipboardMessage, setHideClipboardMessage] = useState(true);
  
  // toggle show states
  const [showCategories, setShowCategories] = useState(false);
  const [showHeaders, setShowHeaders] = useState(false);

  // const isMounted = useIsMounted();

  const toggleAccordionCategories = () => {
    setShowCategories(!showCategories);
  }
  
  const toggleAccordionHeaders = () => {
    setShowHeaders(!showHeaders);
  }
  
  const headerCellsList = [
    'asset_category',
    'site_ref',
    'Name',
    'Asset Tag',
    'Manufacturer',
    'Serial Number',
    'Model',
    'Photo',
    'Size',
    'next_maintenance_date',
    importIsUpdate && "asset_uid",
  ]

  const initialiseState = () => {
    setTimeout(() => {
      setFile(null);
      setFileName("");
      setMessage("");
      setClipboardMessage({label: "", area: ""});
      setShowCategories(false);
      setShowHeaders(false);
      // setCategoriesList([]);
      setUploadPercentage(0);
      setUploadingSites(false);
      setDownloadingTemplate(false);
      setHideClipboardMessage(true);
    }, [500])
  }

  const hideModal = () => {
    setShowImportModal(false);
  }

  useEffect(() => {
      return () => initialiseState();
  }, [companyId, showImportModal])
  
  // clipboard message timeout logic --------->
  const timeoutRef = useRef(null);

  const triggerClipboardMessage = () => {
    setHideClipboardMessage(false);

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(() => {
      setHideClipboardMessage(true);
    }, 5000);
  };

  useEffect(() => {
    return () => clearTimeout(timeoutRef.current);
  }, []);
  // ------------------------------------------|

  useEffect(() => {
    if (uploadingSites) {
      submittingToast("Preparing File");
    }
  }, [uploadingSites])

  const importAssets = () => {
    if (!companyId) return;
    setUploadingSites(true);
    setShowImportStatus(true);

    const formData = new FormData();
    formData.append("file", file);
    {importIsUpdate && formData.append("update", 1)};

    const source = Axios.CancelToken.source();
    const submit = conxtdOut.post(`/company-assets-bulk/import/${companyId}${importIsCategory && categoryId ? ('/' + categoryId) : ""}`, formData, {
      cancelToken: source.token,
      headers: { "Content-Type": "multipart/form-data" },
      onUploadProgress: (progressEvent) => {
        const percentage = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        setUploadPercentage(percentage);
        setTimeout(() => setUploadPercentage(0), 1500);
      },
    })

      hideModal();

      submit.then(() => {

        // calls toast with link to progress logs
        showSuccessfulToast({
          fileName,
          title: "File Received Successfully",
          scheme: "SCHEME_GREEN",
          large: true,
          history,
          companyId,
        });

        // --------------------------------------|

        setUploadingSites(false);
        setShowImportStatus(false);
        dispatch(loadCompanyAssetsStart({ companyId }));
      })
      .catch((error) => {
        setUploadingSites(false);
        setShowImportStatus(false);
        console.error("Error on importing sites", error);

        const message = error?.message ?? "An error was encountered when retrieving the file";
        showFailedToast({
          fileName,
          title: "Failed To Receive File",
          scheme: "SCHEME_RED",
          message: message ? message : "",
          large: true,
          history,
          companyId,
        });

      });

    return () => {
      source.cancel("Component unmounted, request cancelled");
    }
  };

  const onFileChange = (e) => {
    setFile(e.target.files[0]);
    setFileName(e.target.files[0]?.name);
  };

  const exportTemplate = () => {
    if (!companyId) return;

    const source = Axios.CancelToken.source();
    setDownloadingTemplate(true);

    conxtdOut
      .get(`/company-assets-bulk/import-template/${companyId}${importIsCategory && categoryId ? ('/' + categoryId) : ""}?update=${Number(importIsUpdate)}`,
        { responseType: "arraybuffer", cancelToken: source.token })
      .then((response) => {
        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        saveAs(blob, `CONXTD_Template_Assets_Import_New.xlsx`);
        setDownloadingTemplate(false);
      })
      .catch((error) => {
        setDownloadingTemplate(false);
        console.error("Error exporting template", error);
        Alert({
          text: "Issue exporting template file. Please try again later.",
          icon: "warning",
          showConfirmButton: true,
        });
      });

      return () => {
        source.cancel("Component unmounted, request cancelled");
      }
  };

  {/* shows message of text copied to clipboard */}
    const showClipboardMessage = useCallback(() => {
      if (clipboardMessage.label === "") return null;
      return (
      <div className={`clipboard-container ${hideClipboardMessage ? "hide-message" : "show-message"}`}>
        {clipboardMessage.label !== "" && (
            <Col className="clipboard-container align-items-center" xs="auto" sm="auto" md="auto" lg="auto">
              <Message
                closable={false} 
                additionalStyles = "pl-1 pr-1 pt-0 pb-0"
                msg={`"${clipboardMessage.label}" - copied to clipboard`} 
              />
            </Col>
          )}
      </div>
      )
    }, [clipboardMessage, hideClipboardMessage])

  return (
    <>
      <Modal
        id='bulk-import-assets-modal'
        backdrop='static'    
        centered
        keyboard={false}
        onHide={hideModal}
        show={showImportModal}
        size='lg'
      >
        <Modal.Header
          closeButton
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <Modal.Title className='w-100'>
            <Row className='d-flex justify-content-between align-items-center'>
              <Col xs="auto" sm="auto" md="auto" lg="auto">
                <span>{importIsUpdate ? `Update Existing Assets${importIsCategory ? ' - Category' : ''}` : `Import New Assets${importIsCategory ? ' - Category' : ''}`}</span>
              </Col>
              <Col xs="auto" sm="auto" md="auto" lg="auto">
                <span className='w-100'>{showClipboardMessage()}</span>
              </Col>
            </Row>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <div className={`d-flex flex-column container ${darkMode ? 'darkMode' : ''}`}>

          {!importIsCategory ?
            // Generic Import ------------>
            <>
              <div className="template-container">
                <div>{`Download the CONXTD spreadsheet template to ${importIsUpdate ? "update" : "import"} your assets.`}</div>
                <div className="mt-2 d-flex justify-content-start align-items-center">
                  <Button className="mr-2" onClick={exportTemplate} disabled={downloadingTemplate}>
                    Download Template
                  </Button>
                  {downloadingTemplate && <Loading />}
                </div>
              </div>
                
                <div className='list-container'>
                  <div
                    className={`sub-container d-flex justify-content-between align-items-center flex-row py-2 ${showCategories ? "after" : ""}`}
                    onClick={loadingCategories ? () => {return} : toggleAccordionCategories}
                  >
                    <h6 className='d-flex align-items-center'>Available Categories</h6>
                    {loadingCategories ?
                      <Loading />
                    :
                      <Button>
                        <Icon className={`fas ${showCategories ? "fa-chevron-up" : "fa-chevron-down"} accordion-button`}></Icon>
                      </Button>
                    }
                  </div>
                  <span className={`${showCategories ? "accordion-card-header-after" : "accordion-card-header"}`}>
                    <p className="info-sub-header">
                      These are the Asset Categories currently available in your CONXTD environment that you can import assets to. 
                      Make sure the 'asset_category' column in your spreadsheet includes one of these categories for a successful import.
                    </p>
                    {categoriesList.length > 0 ?
                      <ul className='detail-field list-ul'>
                        {categoriesList.map((category, index) => {
                          const name = category?.name ?? null;
                          return (
                              <li
                                key={index}
                                className='list-item'
                                onClick={() => {
                                  navigator.clipboard.writeText(name)
                                  setClipboardMessage({label: name, area: "title_section"})
                                  triggerClipboardMessage();
                                }}
                              >
                                <Icon className={`fas fa-${category?.icon ?? 'question'} mr-2`} />
                                <span>{category?.name}</span>
                              </li>
                          )
                        })}
                      </ul>
                    :
                      <span className='no-categories-available'>
                        There are no categories available to import to on this company currently.
                      </span>
                    }
                  </span>
                </div>
              </>
              // ----------------------------|
            :
              // Category Import ------------>
              <>
                <div className='template-container'>
                  <CategorySelection
                    key={'category'}
                    companyId={companyId}
                    handleSetCategoryId={setCategoryId}
                    message="1. Choose an Asset Category to import assets for:"
                  />
                </div>

                {importIsUpdate ?
                  <></>
                :
                  <div className='mt-3 template-container'>
                    <div>{`${importIsCategory ? "2. " : ""}Download the CONXTD spreadsheet template to ${importIsUpdate ? "update" : "import"} your assets.`}</div>
                    <div className="mt-2 d-flex justify-content-start align-items-center">
                      {categoryId ?
                        <Button className="mr-2" onClick={exportTemplate} disabled={downloadingTemplate}>
                          Download Template
                        </Button>
                      :
                        <Tooltip
                          placement='top'
                          description='Select an Asset Category before exporting a template file'
                        >
                          <Button className="mr-2" onClick={() => { return }} disabled={true}>
                            Download Template
                          </Button>
                        </Tooltip>
                      }
                      {downloadingTemplate && <Loading />}
                    </div>
                  </div>
                }
              </>
              // ----------------------------|
            }
            
            {!importIsCategory && 
              <div className='list-container'>
                <div
                  className={`sub-container d-flex justify-content-between align-items-center flex-row py-2 ${showHeaders ? "after" : ""}`}
                  onClick={toggleAccordionHeaders}
                >
                  <h6>Required Column Headers</h6>
                  <Button>
                    <Icon className={`fas ${showHeaders ? "fa-chevron-up" : "fa-chevron-down"} accordion-button`}></Icon>
                  </Button>
                </div>
                <span className={`${showHeaders ? "accordion-card-header-after" : "accordion-card-header"}`}>
                  <p className="info-sub-header">
                    Headers required for import (These are the column titles that need to be in your spreadsheet for a successful import).
                    The template available above should have these headers pre-filled for you, but if you are using your own spreadsheet make sure to include these headers with the exact same spelling for a successful import.
                  </p>
                  <ul className='detail-field list-ul'>
                    {headerCellsList.length > 0 &&
                      headerCellsList.map((cellName, index) => {
                        return (
                            <li
                              key={index}
                              className='list-item'
                              onClick={() => {
                                navigator.clipboard.writeText(cellName)
                                setClipboardMessage({label: cellName, area: "title_section"})
                                triggerClipboardMessage();
                              }}
                            >
                              <span>{cellName}</span>
                            </li>
                        )
                      })
                    }
                  </ul>
                </span>
              </div>
            }

            <div>
              <div id="stage-2-container" className="bulk-assets-input">

                <div className='important-info-container'>
                  <span className='font-weight-bold pr-1'>IMPORTANT:</span>
                  <span className=''>a maximum limit of 10,000 rows per import currently applies</span>
                </div>

                <div>Upload your completed spreadsheet here to import your assets.</div>
                <div className="custom-file mt-2 mb-2">
                  <input type="file" className="custom-file-input" id="customFile" onChange={onFileChange} />
                  <label className="custom-file-label" htmlFor="customFile">
                    {fileName}
                  </label>
                </div>

                <div className="mt-2">
                  {uploadingSites && 
                  <div className="d-flex flex-row align-items-center mb-3 mt-2">
                    <span className="mr-1">Processing</span>
                    <Loading />
                  </div>
                  }
                  {importIsCategory && !categoryId ?
                    <Tooltip
                      placement='bottom'
                      description='Select an Asset Category before importing'
                    >
                      <Button style={{ width: "100%" }} variant="success" onClick={importAssets} disabled={uploadingSites || (importIsCategory && !categoryId)}>
                        Import
                      </Button>
                    </Tooltip>

                  :
                    <Button style={{ width: "100%" }} variant="success" onClick={importAssets} disabled={uploadingSites || (importIsCategory && !categoryId)}>
                      Import
                    </Button>
                  }
                </div>

                {message !== "" && (
                  <div className="mt-4">
                    <Message msg={message} />
                  </div>
                )}

              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex justify-content-end">
            <Button className="mr-2 p-2" variant="primary" onClick={hideModal}>
              Close
            </Button>
          </div>
        </Modal.Footer>
      </Modal>

    </>
  )
}

export default BulkImportAssets;